import { createAsyncThunk } from '@reduxjs/toolkit';
import { getThreadVideoSessions } from 'store/chat/services/getThreadVideoSessions.service';

export const getThreadVideoSessionsThunk = createAsyncThunk(
  'chat/getThreadVideoSessions',
  async ({ lastEvaluatedKey, limit } = {}, { getState }) => {
    const { thread } = getState().chatSlice;
    const result = await getThreadVideoSessions(
      thread,
      lastEvaluatedKey,
      limit
    );
    return result;
  }
);
